/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
*/

import {NgModule, ModuleWithProviders, InjectionToken} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FcAgEditorConfig} from './types';
import {FcAgEditorComponent} from './editor.component';
import {FcAgEditorService, FcAgEditorServiceConfig, provideMyServiceOptions} from './editor.service';
import {MenuModule} from './modules/menu/menu.module';
import {MenuComponent} from './modules/menu/menu.component';
import {ImageViewComponent} from './components/image-view/image-view.component';
import {FloatingMenuComponent} from './modules/menu/floating-menu/floating-menu.component';

const FC_AG_EDITOR_CONFIG_TOKEN = new InjectionToken<FcAgEditorConfig>('FcAgEditorConfig');

/** 
 * Editor module.
 */
@NgModule({
    imports: [
        CommonModule,
        MenuModule
    ],
    providers: [],
    declarations: [
        FcAgEditorComponent,
        ImageViewComponent
    ],
    exports: [
        FcAgEditorComponent,
        MenuComponent,
        FloatingMenuComponent
    ]
})

export class FcAgEditorModule {
    /**
     * Extend function.
     * 
     * @param config FcAgEditorConfig.
     * @returns FcAgEditorModule.
     */
    static forRoot(config: FcAgEditorConfig): ModuleWithProviders<FcAgEditorModule> {

        return {
            ngModule: FcAgEditorModule,
            providers: [
                {
                    provide: FC_AG_EDITOR_CONFIG_TOKEN,
                    useValue: config
                },
                {
                    provide: FcAgEditorServiceConfig,
                    useFactory: provideMyServiceOptions,
                    deps: [FC_AG_EDITOR_CONFIG_TOKEN]
                }
            ]
        };
    }

    /**
     * Extend function.
     * 
     * @param config FcAgEditorConfig.
     * @returns FcAgEditorModule.
     */
    static forChild(config: FcAgEditorConfig): ModuleWithProviders<FcAgEditorModule> {
        return {
            ngModule: FcAgEditorModule,
            providers: [
                {
                    provide: FC_AG_EDITOR_CONFIG_TOKEN,
                    useValue: config
                },
                {
                    provide: FcAgEditorServiceConfig,
                    useFactory: provideMyServiceOptions,
                    deps: [FC_AG_EDITOR_CONFIG_TOKEN]
                },
                FcAgEditorService
            ]
        };
    }
}
